module.exports = __webpack_public_path__ + "img/sapIcon.d94fe1b4.jpg";